import SubmitWaste from './SubmitWaste';
import BaseData from './BaseData/BaseData';
import InputSecond from './InputSection/InputSecond';
import InputOverview from './InputSection/InputOverview';
import OutputSecond from './OutputSection/OutputSecond';
import OutputOverview from './OutputSection/OutputOverview';

import store from './submit-waste.store';
import mainStore from '../../store';

export default {
    path: '/submit-waste',
    component: SubmitWaste,
    children: [
      {
        path: '',
        name: 'submit-waste-base',
        component: BaseData,
        beforeEnter: (to, from, next) => {
          const { lastCompositionInput } = store.state;

          const { user } = mainStore.state;

          if (user.user.is_input === true && lastCompositionInput.id) {
            return next({ name: 'submit-waste-input' });
          }
          return next();
        }
      },
      {
        path: '/input',
        name: 'submit-waste-input',
        component: InputSecond,
      },
      {
        path: '/input/overview',
        name: 'submit-waste-input-overview',
        component: InputOverview,
      },
      {
        path: '/output',
        name: 'submit-waste-output',
        component: OutputSecond,
      },
      {
        path: '/output/overview',
        name: 'submit-waste-output-overview',
        component: OutputOverview,
      },
    ],
  };